import React, { Component } from 'react';
import SideNav from '../components/sideNav';
import Tabs from '../components/tabs';

const Home = () => {
    return (
        <>  
            <SideNav />
            <Tabs />
        </>
    );
};

export default Home;